
function extractParameterTokens(route:string)
{
    if(!route)
        return [];

    const tokens:string[] = [];
    for(let i=0; i<route.length; i++)
    {
        if(route[i] === '{')
        {
            let token = '';
            i++;
            while(route[i] !== '}')
            {
                if(route[i] === '{')
                    throw new Error(`route nesting not allowed: ${route}`);

                token += route[i];
                i++;
                if(i === route.length)
                    throw new Error(`route token not closed: ${route}`);
            }
            tokens.push(token);
        }
    }
    return tokens;
}


/**
 * Converts a route template with parameter tokens in curly braces to an Express.js route format.
 *
 * @param routeTemplate - The route template string containing parameter tokens in curly braces.
 * @returns The route template string with parameter tokens replaced by Express.js format.
 * @throws Will throw an error if the route template is invalid.
 */
export function expressRoute(routeTemplate:string)
{
    if(!routeTemplate)
        return routeTemplate;

    extractParameterTokens(routeTemplate); // throws error if route is invalid

    return routeTemplate.replace(/{/g, ':').replace(/}/g, '');
}


/**
 * Constructs a route by replacing tokens in the route template with the provided arguments.
 *
 * @param routeTemplate - The template string containing tokens in the format `{token}`.
 * @param args - An array of strings to replace the tokens in the route template.
 * @param prefix - An optional string to prepend to the constructed route.
 * @returns The constructed route with tokens replaced by the provided arguments, optionally prefixed.
 * @throws Will throw an error if the number of tokens in the route template does not match the number of arguments provided.
 */
export function fetchRoute(routeTemplate:string, args:string[], prefix?:string)
{
    if(!routeTemplate)
        return routeTemplate;

    const tokens = extractParameterTokens(routeTemplate);
    if(tokens.length !== args.length)
        throw new Error(`route token count mismatch: ${routeTemplate}`);

    let newRoute = routeTemplate;
    for(let i=0; i<tokens.length; i++)
    {
        newRoute = newRoute.replace(`{${tokens[i]}}`, args[i]);
    }
    return (prefix||'') + newRoute;
}

export function routeBuilder(routeTemplate:string)
{
    return {
        routeTemplate,
        expressRoute: expressRoute(routeTemplate),
        apiFetchRoute: (args:string[]) => fetchRoute(routeTemplate, args, '/api'),
    };
}